module.exports = __webpack_public_path__ + "files/3acdec91031c4657b00c93d43532fa76.png";